"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icons = require("./Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var jalaaliMonths = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
var gregorianMonths = ['ژانویه', 'فوریه', 'مارچ', 'آپریل', 'می', 'جون', 'جولای', 'آگوست', 'سپتامبر', 'اکتبر', 'نوامبر', 'دسامبر'];

var Months = /*#__PURE__*/function (_React$Component) {
  _inherits(Months, _React$Component);

  var _super = _createSuper(Months);

  function Months(props) {
    var _this;

    _classCallCheck(this, Months);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "nextMonth", function (e) {
      _this.monthClicked(_this.props.month + 1, e);
    });

    _defineProperty(_assertThisInitialized(_this), "prevMonth", function (e) {
      _this.monthClicked(_this.props.month - 1, e);
    });

    _this.state = {
      monthPickerView: false,
      selectedMonth: _this.props.month
    };
    return _this;
  }

  _createClass(Months, [{
    key: "monthClicked",
    value: function monthClicked(i, e) {
      e.preventDefault();
      var clickEvent = this.props.clickEvent;
      if (clickEvent) clickEvent(i);
      this.setState({
        monthPickerView: false,
        selectedMonth: i
      });
    }
  }, {
    key: "closeMonthPreview",
    value: function closeMonthPreview(e) {
      e.preventDefault();
      this.setState({
        monthPickerView: false
      });
    }
  }, {
    key: "renderMonths",
    value: function renderMonths() {
      var _this2 = this;

      var gregorian = this.props.gregorian;
      var selectedMonth = this.state.selectedMonth;
      var result = [];
      var months = gregorian ? gregorianMonths : jalaaliMonths;

      var _loop = function _loop(i) {
        if (selectedMonth === i) {
          result.push( /*#__PURE__*/_react.default.createElement("div", {
            key: i,
            className: "MonthItems selected",
            onClick: function onClick(e) {
              return _this2.closeMonthPreview(e);
            }
          }, months[i - 1]));
        } else {
          result.push( /*#__PURE__*/_react.default.createElement("div", {
            key: i,
            className: "MonthItems",
            onClick: function onClick(e) {
              return _this2.monthClicked(i, e);
            }
          }, months[i - 1]));
        }
      };

      for (var i = 1; months.length >= i; i++) {
        _loop(i);
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          month = _this$props.month,
          gregorian = _this$props.gregorian;
      var monthPickerView = this.state.monthPickerView;
      var months = gregorian ? gregorianMonths : jalaaliMonths;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Section"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Nav",
        onClick: this.prevMonth
      }, /*#__PURE__*/_react.default.createElement(_Icons.PreviousIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Title",
        onClick: function onClick(e) {
          e.preventDefault();

          _this3.setState({
            monthPickerView: !monthPickerView
          });
        }
      }, months[month - 1]), /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Nav",
        onClick: this.nextMonth
      }, /*#__PURE__*/_react.default.createElement(_Icons.NextIcon, null)), monthPickerView && /*#__PURE__*/_react.default.createElement("div", {
        className: "MonthPicker"
      }, this.renderMonths()));
    }
  }]);

  return Months;
}(_react.default.Component);

var _default = Months;
exports.default = _default;